module.exports = __webpack_public_path__ + "static/hero-05-9335d718dd13d7672964e73952ad9fe8.jpg";